var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadestrandSted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.961,3.4a5.025,5.025,0,0,1,.622,1.368.234.234,0,0,0,.3.155c.809-.279,1.344-.576,1.29-.831-.315-1.472-2.016-2.4-3.95-2.184a.017.017,0,0,0,0,.032,3.716,3.716,0,0,1,.714.394A3.988,3.988,0,0,1,8.961,3.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,5.863a.217.217,0,0,0,.2-.253,4.563,4.563,0,0,1-.029-1.4,4.2,4.2,0,0,1,.414-1.323,4.258,4.258,0,0,1,.465-.728.016.016,0,0,0-.018-.026c-1.779.575-2.953,2.037-2.649,3.462C3.143,5.856,3.8,5.923,4.7,5.863Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.23,10.44,10.844,9.6c-.108-.038-.218-.073-.328-.1a5.771,5.771,0,0,0-2.4-.164L7.473,5.5c.553-.114,1.1-.246,1.584-.387a.23.23,0,0,0,.156-.284,4.89,4.89,0,0,0-.607-1.34A3.834,3.834,0,0,0,7.62,2.462a3.5,3.5,0,0,0-.87-.451l-.085-.028a.208.208,0,0,0-.1-.006h0c-.075.014-.149.031-.222.048a.2.2,0,0,0-.1.062,4.016,4.016,0,0,0-.59.868,4.1,4.1,0,0,0-.4,1.277,4.435,4.435,0,0,0,.029,1.348.27.27,0,0,0,.3.224c.47-.053.978-.131,1.488-.226l.639,3.827A5.968,5.968,0,0,0,7,9.6l-.342.12-2,.549c-.063.017-.122.064-.071.1s.233.165.322.242a.72.72,0,0,0,1.1,0,1.556,1.556,0,0,1,2.225,0,.717.717,0,0,0,1.1,0,1.554,1.554,0,0,1,2.223,0,.724.724,0,0,0,.55.257l.011,0,1.045-.034a.206.206,0,0,0,.068-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.147,11.5a.819.819,0,0,1-.619-.284,1.45,1.45,0,0,0-2.083,0,.822.822,0,0,1-1.243,0,1.449,1.449,0,0,0-2.082,0,.824.824,0,0,1-1.245,0,1.453,1.453,0,0,0-2.085,0,.831.831,0,0,1-.623.284.32.32,0,0,0,0,.64A1.45,1.45,0,0,0,3.21,11.7a.825.825,0,0,1,1.245,0,1.45,1.45,0,0,0,2.085,0,.822.822,0,0,1,1.241,0,1.45,1.45,0,0,0,2.085,0,.821.821,0,0,1,1.24,0,1.443,1.443,0,0,0,1.041.442.32.32,0,0,0,0-.64Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadestrandSted);
export default __webpack_public_path__ + "static/media/BADESTRAND-STED.c07b7e5c75f766ca85f99c98786efdf9.svg";
export { ForwardRef as ReactComponent };